import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../../Core/Image';

export const CardName = styled.div`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
`;

export const CardDescription = styled.div`
  font-size: 1rem;
  color: ${themeGet('colors.grey-text')};
`;

export const Block = styled.div`
  overflow: hidden;
  height: ${({ isOpen }) => (isOpen ? '100%' : '700px')};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-row: 1 / -1;
    grid-template-rows: subgrid;
    border-radius: 0.75rem;
  }
`;

export const Content = styled.div`
  > div {
    margin: 0;
    padding-top: 1.25rem;
    border-top: 1px solid ${themeGet('colors.cta-border-grey')};
  }
  h4 {
    margin: 0 1.5rem;
  }
  ul {
    li {
      list-style: none;
      margin: 0.5rem 1.5rem;
      vertical-align: middle;
    }
    li:last-child {
      margin-bottom: 1.5rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-row: 5 / 10;
    grid-template-rows: subgrid;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  bottom: 100%;
  z-index: 1;
`;

export const Img = styled(Image)`
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  object-fit: contain;
  height: 168px;
  width: 100%;
  margin: 0 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 200px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 2rem 1.25rem 1.25rem;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    row-gap: 1rem;
    grid-row: 1 / 5;
    grid-template-rows: subgrid;
    p {
      font-size: 1.5rem;
    }
  }
`;

export const CtaSection = styled.div`
  display: grid;
  grid-row: 10 / 11;
  grid-template-rows: subgrid;
  border-top: 1px solid ${themeGet('colors.cta-border-grey')};
  margin-bottom: 1rem;
  padding: 0 1rem;
`;

export const CardTitle = styled.div`
  display: grid;
  grid-row: 3 / 5;
  grid-template-rows: subgrid;
`;
